import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { withHandlers } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import styles from './BreakPrompt.styles'
import { setCountdownValue } from 'store/interactions'
import { timerStart, seconds, minutes } from 'utils/timer'
import { STAGE_TASK_CHOICE, STAGE_BREAK_COUNTER } from 'constants'

const startBreakTimer = props => breakDesc => {
  const { firebase, updateCounter } = props
  const mins = 5
  const now = Date.now()

  firebase.updateProfile({
    stage: STAGE_BREAK_COUNTER,
    breakDesc: breakDesc,
    lastSeen: now,
  })

  timerStart({
    interval: seconds(1),
    duration: minutes(mins),
    intervalFn: updateCounter,
  }).then(() => {
    firebase.updateProfile({
      stage: STAGE_TASK_CHOICE,
      lastSeen: now,
    })
  })
}

export default compose(
  firebaseConnect(props => [`users/${props.uid || ''}`]),
  connect(
    ({ firebase }) => ({
      uid: firebase.profile.uid,
    }),
    dispatch => ({
      updateCounter: val => dispatch(setCountdownValue(val)),
    })
  ),
  withHandlers({
    startBreakTimer,
  }),
  withStyles(styles)
)



// WEBPACK FOOTER //
// ./src/components/BreakPrompt/BreakPrompt.enhancer.js